import PropTypes from 'prop-types';
import React from 'react';

const MessageProps = {
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  timestamp: PropTypes.string.isRequired,
};

const ActionMessageProps = {
  ...MessageProps,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func,
    })
  ).isRequired,
};

const MessageBaseProps = {
  timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  links: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ),
};

const SentMessageProps = {
  ...MessageBaseProps,
  content: PropTypes.string.isRequired,
  read: PropTypes.bool,
};

const ReceivedMessageProps = {
  ...MessageBaseProps,
  content: PropTypes.string.isRequired,
};

const ListMessageProps = {
  ...MessageBaseProps,
  body: PropTypes.shape({
    text: PropTypes.string.isRequired,
  }).isRequired,
  action: PropTypes.shape({
    button: PropTypes.string.isRequired,
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        rows: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            description: PropTypes.string,
          })
        ).isRequired,
      })
    ).isRequired,
  }),
  onSelect: PropTypes.func,
};

const ButtonMessageProps = {
  ...MessageBaseProps,
  body: PropTypes.shape({
    text: PropTypes.string.isRequired,
  }).isRequired,
  footer: PropTypes.shape({
    text: PropTypes.string,
  }),
  action: PropTypes.shape({
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        reply: PropTypes.shape({
          title: PropTypes.string.isRequired,
          id: PropTypes.string.isRequired,
        }).isRequired,
      })
    ).isRequired,
  }).isRequired,
};

const QuotedMessageProps = {
  ...MessageBaseProps,
  content: PropTypes.string.isRequired,
  quotedContent: PropTypes.string.isRequired,
  quotedSender: PropTypes.string,
  read: PropTypes.bool,
  sent: PropTypes.bool,
};

const ListModalProps = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      icon: PropTypes.node,
    })
  ).isRequired,
  onSelect: PropTypes.func,
  helperText: PropTypes.string,
};

export {
  MessageProps,
  ActionMessageProps,
  SentMessageProps,
  ReceivedMessageProps,
  ListMessageProps,
  ButtonMessageProps,
  QuotedMessageProps,
  ListModalProps,
};
